import React, {useEffect, useState} from 'react';
import {getLocale}                  from '@karpeleslab/klbfw';
import {isObject}                   from '../../utils/misc';
import {Grid}                       from '@mui/material';
import ImageList                     from '@mui/material/ImageList';
import ImageListItem                 from '@mui/material/ImageListItem';
import FullscreenIcon               from '@mui/icons-material/Fullscreen';
import IconButton                   from '@mui/material/IconButton';
import ImageListItemBar              from '@mui/material/ImageListItemBar';
import {TEMPLATE_IMAGE_VARIATION}   from '../../../store/reducers/TemplateReducer';

const TemplateGallery = ({template}) => {
	const [gallery, setGallery] = useState([]);

	useEffect(() => {
		if (!isObject(template.Images)) {
			setGallery([]);
			return;
		}
		const locale = getLocale();
		if (locale in template.Images) {
			setGallery(template.Images[locale]);
		} else {
			const available = Object.keys(template.Images);
			if (available.length < 1) setGallery([]);
			else setGallery(template.Images[available[0]]);
		}
	}, [template, setGallery]);

	if (gallery.length < 1) return <></>;
	return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
				<ImageList cellHeight={180} cols={3}>
					{gallery.map(img => {
							return (
                                <ImageListItem key={img.Image_Drive_Item__}>
                                    <img src={img.Image_Drive_Item.Media_Image[TEMPLATE_IMAGE_VARIATION]}
                                         alt={img.Description}/>
                                    <ImageListItemBar
                                        title={img.Description}
                                        actionIcon={
                                            <IconButton
                                                onClick={() => {
                                                    window.open(img.Image_Drive_Item.View_Url, '_blank').focus();
                                                }}
                                                size="large">
                                                <FullscreenIcon/>
                                            </IconButton>
                                        }
                                    />
                                </ImageListItem>
                            );
						}
					)}
				</ImageList>
			</Grid>
        </Grid>
    );
};

export default TemplateGallery;